import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { formatYearMonthDate } from 'utils'
import { Input } from 'lp-components'
import {
  NestedAttributesFieldArray,
  ReadOnlyCellInput,
  DateInput,
} from 'components'

const propTypes = {
  credentials: PropTypes.array,
  change: PropTypes.func.isRequired,
  flashErrorMessage: PropTypes.func.isRequired,
}

const defaultProps = {}

function LearningRow({
  fields,
  index,
  change,
  credentials,
  flashErrorMessage,
}) {
  const field = fields.name ? `${fields.name}[${index}]` : `${index}`
  const credential = fields.get(index)

  if (credential.credentialType !== 'professional_learning') {
    return null
  }

  const isEditing = credential?.isEditing

  const setIsEditing = (isEditing) => {
    const canSave =
      credential.institutionName &&
      credential.credentialName &&
      credential.issueDate &&
      credential.creditsHours
    if (!isEditing) {
      if (!canSave) {
        flashErrorMessage('Please fill in all fields before saving.')
        return
      }
    }
    const updatedCredential = { ...credential, isEditing }

    const updatedCredentials = [...credentials]
    updatedCredentials[index] = updatedCredential
    change('credentials', updatedCredentials)
  }

  return (
    <div key={credential.id || index} className="form-table-row">
      <div className="form-table-cell">
        <Field
          name={field + '.credentialName'}
          label={false}
          component={isEditing ? Input : ReadOnlyCellInput}
          placeholder="Enter school name"
        />
      </div>
      <div className="form-table-cell">
        <Field
          name={field + '.institutionName'}
          label={false}
          component={isEditing ? Input : ReadOnlyCellInput}
          placeholder="e.g., Bachelor's, Master's"
        />
      </div>
      <div className="form-table-cell">
        <Field
          name={field + '.issueDate'}
          label={false}
          component={isEditing ? DateInput : ReadOnlyCellInput}
          placeholderText="MM/DD/YYYY"
          popperPlacement="top"
          className="label-block"
          format={formatYearMonthDate}
          parse={formatYearMonthDate}
        />
      </div>
      <div className="form-table-cell">
        <Field
          name={field + '.creditsHours'}
          label={false}
          type="number"
          component={isEditing ? Input : ReadOnlyCellInput}
          placeholder="e.g., 100"
        />
      </div>
      <div className="form-table-cell">
        <button
          type="button"
          className="button-primary"
          onClick={() => setIsEditing(!isEditing)}
        >
          {isEditing ? 'Save' : 'Edit'}
        </button>
      </div>
      <div className="form-table-cell">
        <button
          type="button"
          className="remove-row"
          aria-label={`Remove ${
            credential.institutionName || 'professional learning'
          } entry`}
          onClick={() => fields.destroy(index)}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
    </div>
  )
}

function LearningFields({ fields, change, credentials, flashErrorMessage }) {
  return (
    <>
      {fields.map((_, i) => {
        return (
          <LearningRow
            key={`credential-${i}`}
            index={i}
            fields={fields}
            change={change}
            credentials={credentials}
            flashErrorMessage={flashErrorMessage}
          />
        )
      })}
    </>
  )
}

function LearningSection({ change, credentials, flashErrorMessage }) {
  const addLearningEntry = () => {
    const newCredential = {
      institutionName: '',
      credentialType: 'professional_learning',
      isEditing: true,
    }
    change('credentials', [...credentials, newCredential])
  }
  return (
    <section>
      <div>
        <div className="form-table">
          <div className="form-table-heading">
            <div className="form-table-row">
              <div className="form-table-head">Name of training</div>
              <div className="form-table-head">Issuing Organization</div>
              <div className="form-table-head">Issue Date</div>
              <div className="form-table-head">Amount of hours</div>
              <div className="form-table-head" style={{ width: 70 }}></div>
              <div className="form-table-head" style={{ width: 20 }}></div>
            </div>
          </div>
          <div className="form-table-body">
            <NestedAttributesFieldArray
              name="credentials"
              component={LearningFields}
              change={change}
              credentials={credentials}
              flashErrorMessage={flashErrorMessage}
            />
          </div>
        </div>
      </div>
      <button type="button" className="link-black" onClick={addLearningEntry}>
        + Add New Professional Learning
      </button>
    </section>
  )
}

LearningSection.propTypes = propTypes
LearningSection.defaultProps = defaultProps

export default LearningSection
